import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import {
    type ICompanyDetailForAgentClient,
    IGetResponse as ICompanyDetailForAgentResponse,
} from 'interfaceAdapter/gatewaySchemas/ICompanyDetailForAgentClient';
import {
    type IBuyerDetailForAgentClient,
    IGetResponse as IBuyerDetailForAgentResponse,
} from 'interfaceAdapter/gatewaySchemas/IBuyerDetailForAgentClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class SupporterCompanyDetailQuery {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('ICompanyDetailForAgentClient')
        public readonly companyDetailForAgentClient: ICompanyDetailForAgentClient,
        @inject('IBuyerDetailForAgentClient')
        public readonly buyerDetailForAgentClient: IBuyerDetailForAgentClient,
    ) {}

    public async fetchCompanyDetail(companyId: number): Promise<ICompanyDetailForAgentResponse['data']> {
        const { data, message } = await this.companyDetailForAgentClient.get({
            supporterToken: this.supportUserToken.get() || '',
            companyId,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }

    public async fetchBuyerDetail(buyerId: number): Promise<IBuyerDetailForAgentResponse['data']> {
        const { data, message } = await this.buyerDetailForAgentClient.get({
            supporterToken: this.supportUserToken.get() || '',
            buyerId,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
